module.exports = __webpack_public_path__ + "static/media/lib2.64551d4f.jpeg";